/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getClassroom = /* GraphQL */ `
  query GetClassroom($classroomId: String!, $providerArn: String) {
    getClassroom(classroomId: $classroomId, providerArn: $providerArn) {
      classroom {
        classroomId
        langLocale
        courseId
        providerArn
        courseTitle
        courseAbstract
        courseDescription
        courseLevel
        startsOn
        endsOn
        locationData {
          timezone
          displayName
          longitude
          latitude
          locationType
          virtualUrl
          physicalAddress {
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
          }
        }
        studentGuide {
          custom_vbid
        }
        callsToAction {
          locationType
          url
          label
          actionType
          icon
          iconPosition
        }
        accessCodes {
          accessCode
          accessCodeCapacity
          accessCodeCapacityUsed
        }
        classCapacity
        studentCount
        supportedRegions
        createdBy
        accessType
        isCancellable
        subProviderCapacity {
          subProviderArn
          capacity
        }
      }
      course {
        courseId
        title
        description
        langLocale
        abstract
        level
      }
      content {
        contentId
        title
        description
        level
        duration
        durationUnit
        isActive
        supportedRegions
      }
      jamTrainings {
        trainings {
          context
          trainingId
          trainingType
          contentId
          requestClientToken
          isActive
          fulfillmentStatus
          fulfillmentError {
            message
            code
          }
          created
          lastUpdate
          metaData {
            eventId
            eventCode
            eventStatus
            testCloneEventId
            testCloneEventCode
            testCloneEventSuffix
            startsOn
            endsOn
            timezone
            maxTeamSize
            maxExpectedParticipants
            eventURL
            testEventURL
            adminEventURL
          }
        }
        nextToken
      }
    }
  }
`;
export const getStudentTrainingsByClassroomId = /* GraphQL */ `
  query GetStudentTrainingsByClassroomId(
    $classroomId: String!
    $accessType: AccessType
  ) {
    getStudentTrainingsByClassroomId(
      classroomId: $classroomId
      accessType: $accessType
    ) {
      studentTrainings {
        lastUpdated
        metaData {
          preferredLangLocale
          labId
          labUrl
          labStatus
          region
          labRegions
        }
        trainingId
        context
        created
        requestClientToken
        arn
        state
        fulfillmentStatus
        userKey
        studentNumber
        firstName
        lastName
      }
    }
  }
`;
export const getIngressUrl = /* GraphQL */ `
  query GetIngressUrl($input: GetIngressUrlInput!) {
    getIngressUrl(input: $input) {
      labId
      consoleUrl
      endsOn
      status
    }
  }
`;
export const getCourseVersions = /* GraphQL */ `
  query GetCourseVersions($input: GetCourseVersionsInput!) {
    getCourseVersions(input: $input) {
      courseVersions {
        courseId
        versionId
        createdOn
        status
        availability
      }
      nextToken
    }
  }
`;
export const getCourseVersion = /* GraphQL */ `
  query GetCourseVersion($courseVersionId: String!) {
    getCourseVersion(courseVersionId: $courseVersionId) {
      courseVersion {
        courseVersionId
        createdOn
        availability
        status
        courseName
        supportedLocales
        blueprintData {
          blueprintName
          arn
        }
        resourceData {
          locale
          description
          title
        }
        contentVersion
        jamConfig {
          challengeSetID
        }
      }
    }
  }
`;
export const getCourseArns = /* GraphQL */ `
  query GetCourseArns {
    getCourseArns {
      courses {
        courseId
        title
      }
    }
  }
`;
export const getProviderArns = /* GraphQL */ `
  query GetProviderArns {
    getProviderArns {
      providers
    }
  }
`;
export const getProvider = /* GraphQL */ `
  query GetProvider($input: GetProviderInput!) {
    getProvider(input: $input) {
      provider {
        name
        arn
        type
        subProviderData {
          providerName
          providerType
          providerArn
          providerMetaData {
            isParentProvider
            parentProviderArn
          }
        }
      }
    }
  }
`;
export const getServiceSchedule = /* GraphQL */ `
  query GetServiceSchedule($input: GetServiceScheduleInput!) {
    getServiceSchedule(input: $input) {
      schedules {
        service
        domain
        endTime
        startTime
        event
        type
      }
    }
  }
`;
export const getProviderReport = /* GraphQL */ `
  query GetProviderReport($input: GetProviderReportInput!) {
    getProviderReport(input: $input) {
      presignedUrl
    }
  }
`;
export const listUserRelationships = /* GraphQL */ `
  query ListUserRelationships($input: ListUserRelationshipsInput!) {
    listUserRelationships(input: $input) {
      relationships
    }
  }
`;
export const listClassroomRelationships = /* GraphQL */ `
  query ListClassroomRelationships($input: ListClassroomRelationshipsInput!) {
    listClassroomRelationships(input: $input) {
      classroomUsers {
        email
        userKey
        firstName
        lastName
        hasAcceptedInvitation
      }
      emails
    }
  }
`;
export const listUserClassrooms = /* GraphQL */ `
  query ListUserClassrooms($input: ListClassroomsInput!) {
    listUserClassrooms(input: $input) {
      classrooms {
        classroomArn
        providerArn
        langLocale
        courseId
        startsOn
        endsOn
        locationData {
          timezone
          displayName
          longitude
          latitude
          locationType
          virtualUrl
          physicalAddress {
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
          }
        }
        courseTitle
        createdByEmail
        instructorEmails
      }
      nextToken
    }
  }
`;
export const listProviderClassrooms = /* GraphQL */ `
  query ListProviderClassrooms($input: ListClassroomsInput!) {
    listProviderClassrooms(input: $input) {
      classrooms {
        classroomArn
        providerArn
        langLocale
        courseId
        startsOn
        endsOn
        locationData {
          timezone
          displayName
          longitude
          latitude
          locationType
          virtualUrl
          physicalAddress {
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
          }
        }
        courseTitle
        createdByEmail
        instructorEmails
      }
      nextToken
    }
  }
`;
export const listProviderReports = /* GraphQL */ `
  query ListProviderReports($input: ListProviderReportsInput!) {
    listProviderReports(input: $input) {
      iltReports {
        reportId
        reportName
        reportDate
        reportDescription
        createdDate
      }
      nextToken
    }
  }
`;
export const listCourses = /* GraphQL */ `
  query ListCourses($input: ListCoursesInput!) {
    listCourses(input: $input) {
      courses {
        title
        id
      }
    }
  }
`;
export const listMajorCourseVersions = /* GraphQL */ `
  query ListMajorCourseVersions($input: ListMajorCourseVersionsInput) {
    listMajorCourseVersions(input: $input) {
      collections {
        collectionArn
        collectionTitle
      }
      nextToken
    }
  }
`;
export const listInstructorClassroomsV2 = /* GraphQL */ `
  query ListInstructorClassroomsV2($input: ListInstructorClassroomsV2Input!) {
    listInstructorClassroomsV2(input: $input) {
      classrooms {
        classroomArn
        providerArn
        langLocale
        courseId
        startsOn
        endsOn
        locationData {
          timezone
          displayName
          longitude
          latitude
          locationType
          virtualUrl
          physicalAddress {
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
          }
        }
        courseTitle
        createdByEmail
        instructorEmails
      }
      count
      countType
      aggregations {
        courseTitle {
          items {
            value
            count
          }
          countType
        }
        langLocale {
          items {
            value
            count
          }
          countType
        }
        country {
          items {
            value
            count
          }
          countType
        }
      }
    }
  }
`;
export const listProviderClassroomsV2 = /* GraphQL */ `
  query ListProviderClassroomsV2($input: ListProviderClassroomsV2Input!) {
    listProviderClassroomsV2(input: $input) {
      classrooms {
        classroomArn
        providerArn
        langLocale
        courseId
        startsOn
        endsOn
        locationData {
          timezone
          displayName
          longitude
          latitude
          locationType
          virtualUrl
          physicalAddress {
            addressLine1
            addressLine2
            city
            state
            postalCode
            country
          }
        }
        courseTitle
        createdByEmail
        instructorEmails
      }
      count
      countType
      aggregations {
        courseTitle {
          items {
            value
            count
          }
          countType
        }
        langLocale {
          items {
            value
            count
          }
          countType
        }
        country {
          items {
            value
            count
          }
          countType
        }
      }
    }
  }
`;
